export {
  Byline,
  Heading3,
  Heading4,
  HeadingLink,
  headingLinkOnHoverMixin
} from "./Text";
